<template>
  <section id="projects" class="section">
    <div class="section-inner">
      <header v-reveal class="projects-head">
        <span class="eyebrow">03 — projetos</span>
        <h2 class="section-title">O que eu venho construindo</h2>
        <p class="section-lead">
          Plataformas SaaS, times de agentes de IA e sistemas de gestão — dos
          primeiros requisitos até o deploy em produção.
        </p>
      </header>

      <div class="featured">
        <article
          v-for="(project, i) in featured"
          :key="project.name"
          v-reveal="i * 90"
          class="feature-card"
        >
          <div class="feature-top">
            <span class="feature-tag mono">{{ project.tag }}</span>
            <span class="feature-company mono">{{ project.company }}</span>
          </div>

          <h3 class="feature-name">{{ project.name }}</h3>
          <p class="feature-desc">{{ project.description }}</p>

          <ul class="feature-points">
            <li v-for="point in project.points" :key="point">{{ point }}</li>
          </ul>

          <ul class="chips">
            <li v-for="tech in project.stack" :key="tech" class="chip mono">
              {{ tech }}
            </li>
          </ul>
        </article>
      </div>

      <div class="other-grid">
        <article
          v-for="(project, i) in others"
          :key="project.name"
          v-reveal="i * 60"
          class="other-card"
        >
          <div class="other-head">
            <h4 class="other-name">{{ project.name }}</h4>
            <span class="other-company mono">{{ project.company }}</span>
          </div>
          <p class="other-desc">{{ project.description }}</p>
          <ul class="chips">
            <li v-for="tech in project.stack" :key="tech" class="chip mono">
              {{ tech }}
            </li>
          </ul>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ProjectsPage",

  data() {
    return {
      featured: [
        {
          name: "JurisOne",
          company: "Saas One",
          tag: "agentes de IA",
          description:
            "Plataforma que coloca um time de agentes de IA especializados a serviço de escritórios de advocacia.",
          points: [
            "Leitura e redação autônoma de e-mails e gestão de agenda",
            "Indexação e consulta do acervo documental via RAG",
            "Geração de peças jurídicas formatadas",
          ],
          stack: [
            "ReactJS",
            "Agno",
            "LLMs",
            "RAG",
            "PostgreSQL",
            "GCP",
            "Terraform",
            "Google Workspace",
          ],
        },
        {
          name: "Nexia OS",
          company: "Comeia Labs",
          tag: "plataforma SaaS",
          description:
            "SaaS multiusuário de assistentes de IA construído sobre o OpenClaw, com permissões individuais por usuário.",
          points: [
            "Proxy reverso customizado e portal completo de autenticação",
            "Backoffice de gestão e orquestração em Docker",
            "Hospedagem em VPS dedicada com banco em AWS RDS",
          ],
          stack: [
            "Vue.js 3",
            "Node.js",
            "OpenClaw",
            "Agentes de IA",
            "PostgreSQL",
            "AWS",
            "Docker",
          ],
        },
      ],

      others: [
        {
          name: "AMBEV Taxi",
          company: "Comeia Labs",
          description:
            "Plataforma de gestão de transporte corporativo, com fluxo completo de solicitação e acompanhamento.",
          stack: [
            "Vue.js 3",
            "TypeScript",
            "Vuetify",
            "Vuex",
            "Jest",
            "API Rest",
          ],
        },
        {
          name: "SUAPE",
          company: "Comeia Labs",
          description:
            "Sistema web para o complexo portuário, cobrindo cadastros, autenticação e integrações de backoffice.",
          stack: [
            "Vue.js 2.5",
            "Node.js",
            "Express",
            "MongoDB",
            "Docker",
            "Cypress",
          ],
        },
        {
          name: "Team Culture",
          company: "Comeia Labs",
          description:
            "Produto de gestão de cultura e engajamento de times, com design system próprio em Storybook.",
          stack: ["Vue.js 2.5", "Storybook", "Firebase", "Sass", "Jest"],
        },
        {
          name: "MR League",
          company: "Comeia Labs",
          description:
            "Aplicativo mobile de campeonatos, desenvolvido em React Native com tipagem estrita.",
          stack: ["React Native", "TypeScript"],
        },
        {
          name: "PGE",
          company: "Comeia Labs",
          description:
            "Automação de processos internos sobre o Google Workspace, eliminando etapas manuais recorrentes.",
          stack: ["Google App Script", "Google Workspace", "HTML"],
        },
        {
          name: "ERP Longtech",
          company: "Longtech Software",
          description:
            "ERP personalizado para diferentes segmentos, com levantamento de requisitos direto com o cliente.",
          stack: ["Delphi", "SQL", "Firebird", "Vue.js"],
        },
      ],
    };
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
